import AppThemeIcon from "@core-components/icon/AppThemeIcon";
import useAppTranslation from "@hooks/language/useAppTranslation";
import {
  Avatar,
  Button,
  Checkbox,
  Group,
  Indicator,
  Menu,
  Text,
} from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
import { useState } from "react";
import Icon from "../../shared/icon/Icon";
import TextInput from "../../shared/inputs/TextInput";
import type { ISkinOption } from "../hooks/useSmurfsRankedFilters";

interface ISkinSelectProps {
  values: string[];
  onChange: (value: string[]) => void;
  skins: ISkinOption[];
}

const SkinSelect: React.FC<ISkinSelectProps> = ({
  values,
  onChange,
  skins,
}) => {
  const { t } = useAppTranslation("components.rankedFilters");
  const [search, setSearch] = useState<string>("");

  const data = skins.filter((skin) => {
    if (!search) return true;
    return skin.name.toLowerCase().includes(search.toLowerCase());
  });

  return (
    <Menu>
      <Menu.Target>
        <Indicator
          processing
          classNames={{
            indicator: "before:bg-secret-blue-light bg-secret-blue-light z-10",
          }}
          disabled={values.length === 0}
        >
          <Button
            classNames={{
              root: "default-icon border-primary-lighter",
              section: "contents",
            }}
            leftSection={
              <AppThemeIcon className="size-8">
                <Icon.Skin className="pr-2" size={30} />
              </AppThemeIcon>
            }
            radius={8}
            rightSection={<IconChevronDown />}
          >
            {t("skins.label")}
          </Button>
        </Indicator>
      </Menu.Target>

      <Menu.Dropdown
        classNames={{
          dropdown: "bg-primary-default border-secret-blue-light p-3",
        }}
      >
        <Text
          className="max-w-[320px] text-wrap pb-2 text-primary-dark-text"
          size={"sm"}
        >
          {t("skins.helperText")}
        </Text>
        <TextInput
          placeholder={t("skins.searchPlaceholder")}
          value={search}
          onChange={(value) => {
            if (value === null) {
              setSearch("");
              return;
            }
            setSearch(value as string);
          }}
        />
        <Checkbox.Group
          className="mt-4 max-h-[300px] overflow-y-scroll"
          value={values}
          onChange={onChange}
        >
          {data.map((skin) => (
            <Checkbox
              key={skin.id}
              labelPosition="left"
              classNames={{
                root: "cursor-pointer hover:bg-primary-background py-1 rounded-md",
                label: "cursor-pointer p-1",
                labelWrapper: "w-full",
                body: "my-1 text-white",
                input: "!bg-transparent border-none",
                inner: "my-auto",
              }}
              iconColor="white"
              label={
                <Group>
                  <Avatar src={skin.thumbnail} />
                  {skin.name}
                </Group>
              }
              value={skin.id.toString()}
            />
          ))}
        </Checkbox.Group>
      </Menu.Dropdown>
    </Menu>
  );
};

export default SkinSelect;
